import { useTranslation } from "react-i18next";

export default function Artists({ artists }) {
  const { t } = useTranslation();
  return (
    <div className="mt-4 mb-6">
      {/* SMALL LABEL */}
      <p className="text-[10px] tracking-widest text-green-400/90 uppercase mb-2">
        {t("artists.lineup")}
      </p>
      {/* TITLE */}
      <h2 className="text-xl font-semibold mb-6">{t("artists.title")}</h2>
      {/* GRID */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {artists.map((artist, i) => (
          <div
            key={i}
            className="bg-[#031c15] p-4 rounded-xl border border-green-900/30 text-center hover:border-green-500/30 transition"
          >
            <div className="w-12 h-12 mx-auto mb-2 rounded-full overflow-hidden border border-green-500/40 bg-[#021610] flex items-center justify-center">
              {artist.profile_image ? (
                <img
                  src={artist.profile_image}
                  alt={artist.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-sm">🎧</span>
              )}
            </div>

            <p>{artist.name}</p>
            <p className="text-xs text-gray-400">{artist.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
